export interface IIncomingAlertVisibilityInput {
  newOrdersCount: number;
  callsCount: number;
  effectiveTier: number;
  canManageOrders: boolean;
  isMainPosRoute: boolean;
}

/**
 * Whether the app-bar incoming orders/calls alert should render. Hidden on the
 * main POS page (its incoming pane and header dropdowns already cover it), for
 * tier-0 restaurants, and for members without order management permission.
 */
export function isIncomingAlertVisible(
  input: IIncomingAlertVisibilityInput
): boolean {
  return (
    input.effectiveTier >= 1 &&
    input.canManageOrders &&
    !input.isMainPosRoute &&
    input.newOrdersCount + input.callsCount > 0
  );
}
